import styles from '../widget.module.scss';
import { WidgetTitle } from '../widget-title/WidgetTitle';
import { WidgetActions } from '../widget-actions/WidgetActions';
import { useAtom } from 'jotai';
import { helpTextAtom } from 'stores/dashboard-store/dashboard-store';
import { IconButton, Typography, Icon, ICONS_ENUM } from '@sanlam-glacier/app-common/components';
import { WidgetConfig, WidgetState, WidgetType } from 'modules/dashboard/types';

interface WidgetHeaderProps {
  widgetConfig: WidgetConfig;
  isEditing?: boolean;
  widgetState: WidgetState;
  isWidgetHidden: boolean;
  onHideToggle: () => void;
  onReload: () => void;
  isReloadDisabled: boolean;
}

export const WidgetHeader: React.FC<WidgetHeaderProps> = ({
  widgetConfig,
  isEditing,
  widgetState,
  isWidgetHidden,
  onHideToggle,
  onReload,
  isReloadDisabled
}) => {
  const {
    heading,
    helpHeadingText,
    helpSubText,
    type,
    customActionIcon,
    customActionText,
    hideMoreButton,
    isHidable,
    onInfoClick
  } = widgetConfig;

  const [helpText] = useAtom(helpTextAtom);

  return (
    <div data-testid={`${type}HeadingContainer`} className={styles.headingContainer}>
      <div className={styles.widgetHeader}>
        {isEditing && (
          <div className={styles.dragHandle}>
            <IconButton size={IconButton.SIZE.X_SMALL} variant={IconButton.VARIANT.TERTIARY}>
              <Typography color={Typography.COLOR.PRIMARY}>
                <Icon icon={ICONS_ENUM.ACTION_DRAG_INDICATOR} />
              </Typography>
            </IconButton>
          </div>
        )}
        <WidgetTitle
          type={type ?? WidgetType.unknown}
          heading={heading ?? ''}
          helpHeadingText={
            widgetConfig.type === WidgetType.personalDetails ? helpText.heading : helpHeadingText
          }
          helpSubText={
            widgetConfig.type === WidgetType.personalDetails ? helpText.subText : helpSubText
          }
        />
      </div>
      {(widgetState !== WidgetState.Loading || isWidgetHidden) && (
        <WidgetActions
          type={type ?? WidgetType.unknown}
          isHidable={isHidable}
          isWidgetHidden={isWidgetHidden}
          customActionIcon={customActionIcon}
          customActionText={customActionText}
          hideMoreButton={hideMoreButton}
          onHideToggle={onHideToggle}
          onInfoClick={onInfoClick}
          onReload={onReload}
          isReloadDisabled={isReloadDisabled}
        />
      )}
    </div>
  );
};
